module.exports = __webpack_public_path__ + "img/manchester-university-logo.82c9ba11.png";